import React, { Fragment } from 'react';

import './open.scss';
import { Button } from 'antd';
import Item from './Item';
import { images } from 'assets/images';
import { useHistory } from 'react-router';
import rarity from 'assets/images/rarity.png';
import rarity1 from 'assets/images/rarity-1.png';
import rarity4 from 'assets/images/rarity-4.png';
import rarity3 from 'assets/images/rarity-3.png';
import rarity2 from 'assets/images/rarity-2.png';
import { CircularProgress, makeStyles } from '@material-ui/core';
import { blue } from '@material-ui/core/colors';
const useStyles = makeStyles({
  buttonProgress: {
    color: blue[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
});

export default function Legend(props) {
  const { openDetail, loading } = props;
  const history = useHistory();
  const genClass = () => {
    if (openDetail) {
      if (!loading) {
        switch (openDetail.nft_type.id) {
          case 1:
            return 'legend-open legend-class';
          case 2:
            return 'legend-open epic-class';
          case 3:
            return 'legend-open super-rare ';
          case 4:
            return 'legend-open rare';
          case 5:
            return 'legend-open common';
            break;
            return 'legend-open loading-class';
        }
      }
    }

    return 'legend-open loading-class';
  };
  const classOpen = !loading ? 'legend-open legend-class' : 'legend-open loading-class';
  return (
    <Fragment>
      <div className='open-b'>
        <div className={genClass()}>
          <div className='item-open'>
            <Item loading={loading} openDetail={openDetail && openDetail != '<nil>' ? openDetail : null} />
          </div>
          <Fragment>
            <div style={{ visibility: loading ? 'hidden' : '' }}>
              <div className='name' style={{ textAlign: 'center' }}>
                {openDetail && openDetail.user_nft.name}
              </div>
              {/* <div className="level1">
                       <img className="image-item" width="120px" src={rarity} />
                   </div> */}
              <div className='group-btn-box d-flex'>
                <Button onClick={() => history.push('/app/box-profile')} className='btn-lb'>
                  Go to profile
                </Button>
                <Button
                  onClick={() => history.push(`/app/item-detail-sale/${openDetail && openDetail.user_nft.id}`)}
                  className='buy view'
                >
                  View details
                </Button>
              </div>
            </div>
          </Fragment>
        </div>
      </div>
    </Fragment>
  );
}
